import SheetComponent from "./index";

import {Trans} from "@lingui/react/macro"
import {t} from "@lingui/core/macro"
import {checkPermissions, currencyFormat} from "../../components/permissions/functions";
import {DynamicIcon} from "lucide-react/dynamic";
import moment from "moment";
import {MobCard} from "../components/MobCard";
import ApiService from "../../services/ApiService";
import React, {Fragment} from "react";
import { API_BASE_URL, ASSET_BASE_URL, isMobileApp, MOBCOLORS, MOBILE_PREFIX_PATH } from '../../configs/AppConfig';
import ModalLink from "../../modals/ModalLink";
import ModalUser from "../../modals/ModalUser";
import ModalContact from "../../modals/ModalContact";
import ModalCerfa from "../../modals/ModalCerfa";
import ModalEditCerfa from "../../modals/ModalEditCerfa";
import ModalCerfaGroupe from "../../modals/ModalCerfaGroupe";
import ModalChangeContact from "../../views/app-views/paiements/ModalChangeContact";
import ModalChangeOrigin from "../../views/app-views/paiements/ModalChangeOrigin";
import ModalDeletePaiement from "../../views/app-views/paiements/ModalDeletePaiement";
import ModalMessages from "../../views/app-views/messages/ModalEdit";
import {useActionSheet, withActionSheet} from "../providers/ActionSheetProvider";
import {MobEditButtonIcon} from "../components/MobEditButtonIcon";
import MobPressable from "../components/MobPressable";
import {useNavigate} from "react-router-shim";
import FicheSubmit from "../../views/app-views/form/data";
import {getStates} from "../../views/app-views/form/functions";
import {notification, Select} from "antd";
import IntlMessage from "../../components/util-components/IntlMessage";
import {getSubmitCardActions} from "../../views/mobile-views/submit/submitCardActions";
import modalLink from "../../modals/ModalLink";

class SheetSubmitDetail extends SheetComponent
{
    constructor(props) {
        super(props);
    }

    onClose(){

    }

    componentDidMount(){
        this.getAssocs()
    }

    async getAssocs() {
        var res = await ApiService.get("/auth/assoc")
        if (res.success) {
            this.setState({assocs: res.data})
        }
    }

    async onChangeCustomStatus(id, status = []) {
        await ApiService.post("/forms_submit/customStatus/" + id, {status: status})
    }


    async onResend(id) {
        if (!checkPermissions(["submit.edit"])) {
            notification.error({
                message: <IntlMessage id="access.error"/>
            })
            return false
        }
        await ApiService.get("/forms_submit/resend/" + id)

        notification.success({
            message: <IntlMessage id="success.send"/>
        })
    }

    async onValidate(id) {
        if (!checkPermissions(["submit.edit"])) {
            notification.error({
                message: <IntlMessage id="access.error"/>
            })
            return false
        }

        await ApiService.get("/forms_submit/valide/" + id)

        notification.success({
            message: <IntlMessage id="success.enable"/>
        })

        await this.getData()
    }

    async onInvalidate(id) {
        if (!checkPermissions(["submit.edit"])) {
            notification.error({
                message: <IntlMessage id="access.error"/>
            })
            return false
        }
        await ApiService.get("/forms_submit/invalide/" + id)

        notification.success({
            message: <IntlMessage id="success.enable"/>
        })

        await this.getData()
    }


    async onArchive(id) {
        if (!checkPermissions(["submit.archive"])) {
            notification.error({
                message: <IntlMessage id="access.error"/>
            })
            return false
        }
        await ApiService.get("/forms_submit/archive/" + id)

        notification.success({
            message: <IntlMessage id="success.edit"/>
        })

        await this.getData()
    }

    async onUnarchive(id) {
        if (!checkPermissions(["submit.archive"])) {
            notification.error({
                message: <IntlMessage id="access.error"/>
            })
            return false
        }
        await ApiService.get("/forms_submit/unarchive/" + id)

        notification.success({
            message: <IntlMessage id="success.edit"/>
        })

        await this.getData()
    }

    renderContent()
    {
        const sheetContext=this.props.sheetContext
        const payload=sheetContext.getPayload()

        const item= payload?.params?.item
        if(!item){
            return null
        }
        const row=item

        console.log(item)

        var assoc = null
        if (this.state?.assocs?.length > 0) {
            assoc = this.state.assocs.find(i => i.value === item.assoc)
        }

        var MENU = getSubmitCardActions({
            item:item,
            form:item.form,
            modalLink:this.modalLink,
            functions:this
        })

        let DropdownComponent=null
        if(!isMobileApp){
            DropdownComponent= this.props.actionSheetManager.toDropdown(MENU)
            //console.log("DropdownComponent", DropdownComponent)
        }

        const formName=item.form.label || item.form.title

        const paiementMethod = row?.data?.__paiementMethod || t`En Ligne`

        let color=MOBCOLORS.orange.color
        let symbol=""

        if(item.payed>0){
            color=MOBCOLORS.green.color
            symbol="+"
        }

        const isArchived=row.archived || false
        const stateCode=isArchived?"ARCHIVED":item.state
        const state = getStates().find(i => i.value === stateCode)

        return(
            <div style={{display:"flex",flexDirection:"column",gap:10}}>

                <div style={{display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center",textAlign:"center",gap:0}}>
                    <span style={{fontSize:15}}>{moment(item.datetime).format("DD/MM/YYYY à HH:mm")}</span>
                    <span style={{fontSize:18,fontWeight:"bold",color:MOBCOLORS.blue.color}}>{formName}</span>
                </div>


                <div style={{display:"flex",flexDirection:"column",gap:20}}>
                    <MobCard style={{display:"flex",flexDirection:"column",gap:10,position:"relative"}}>

                        <div style={{position:"absolute",right:0,paddingRight:10,paddingTop:5}}>
                            {isMobileApp ?(
                                <MobEditButtonIcon icon={"ellipsis-vertical"} onClick={()=>{
                                    if(MENU.length>0) {
                                        this.props.actionSheetManager.open(MENU)
                                    }
                                }}/>
                            ):(
                                <DropdownComponent>
                                    <a onclick={(e)=>e.preventDefault()}>
                                        <MobEditButtonIcon icon={"ellipsis-vertical"}/>
                                    </a>
                                </DropdownComponent>
                            )}
                        </div>


                        {item.total>0 ?(
                            <>
                                <span style={{
                                    alignSelf: "center",
                                    color: color,
                                    fontWeight: "bold",
                                    fontSize: 26
                                }}>{symbol} {currencyFormat(item.payed / 100, item.devise)}</span>

                                <div style={{
                                    display: "flex",
                                    width: "100%",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    padding: "0 5%"
                                }}>
                                    <span style={{alignSelf:"center",color:MOBCOLORS.gray.color,fontSize:15,fontStyle:"italic",fontWeight:"300"}}><Trans>Total</Trans> : <span style={{fontWeight:"bold",fontStyle:"normal"}}>{currencyFormat(item.total / 100,item.devise)}</span></span>

                                    <span style={{alignSelf:"center",opacity:item.totalCerfa>0?1:0,color:MOBCOLORS.cyan.color,fontSize:15,fontStyle:"italic",fontWeight:"300"}}><Trans>Total Cerfa</Trans> : <span style={{fontWeight:"bold",fontStyle:"normal"}}>{currencyFormat(item.totalCerfa  / 100,item.devise)}</span></span>
                                </div>
                            </>
                        ):(
                            <div style={{paddingTop:25}}/>
                        )}

                        <Divider/>

                        {assoc &&(
                            <Item name={(<Trans>Association</Trans>)} value={assoc.label}/>
                        )}

                        {item.contact &&(
                            <Item name={(<Trans>Contact</Trans>)}>
                                <span style={{display:"flex",alignItems:"center",gap:5,textDecorationLine:"underline",cursor:"pointer"}} onClick={()=>{
                                    //this.props.sheetContext.cancel()
                                    //this.props.navigate(MOBILE_PREFIX_PATH+"/contacts/fiche?id="+item.contact.id)
                                    this.props.sheetContext.openContact(item.contact)

                                }}>
                                    <DynamicIcon name={"contact"} color={MOBCOLORS.blue.color} size={18}/>
                                    {item.contact?.nom} {item.contact?.prenom}
                                </span>
                            </Item>
                        )}


                        {item.payed>0 &&(
                        <Item name={(<Trans>Paiements</Trans>)}>
                                <span style={{display:"flex",alignItems:"center",gap:5,textDecorationLine:"underline",cursor:"pointer"}} onClick={()=>{
                                    this.props.sheetContext.cancel()

                                    let mobHeaderTitle=encodeURIComponent(formName)
                                    let routeParam="?&searchId="+item.id+"&contactName="+mobHeaderTitle
                                    this.props.navigate(MOBILE_PREFIX_PATH+"/paiements/list"+routeParam)
                                }}>
                                    <Trans>Voir les paiements</Trans>
                                </span>
                        </Item>
                        )}

                        {Array.isArray(item.form?.paiementMethods) && item.form.paiementMethods.length > 0 &&(
                            <>
                                <Item name={(<Trans>Méthode paiement</Trans>)} value={paiementMethod}/>
                            </>
                        )}

                        <Item name={(<Trans>Statut</Trans>)} value={state.text} color={MOBCOLORS[state.color].color}/>

                        {item.total>0 &&(
                            <>
                                <Item name={(<Trans>Total</Trans>)} value={currencyFormat(item.total / 100, item.devise)}/>

                                {item.totalCerfa>0 &&(
                                    <Item name={(<Trans>Total Cerfa</Trans>)} value={currencyFormat(item.totalCerfa / 100, item.devise)} color={MOBCOLORS.cyan.color}/>
                                )}

                                <Item name={(<Trans>Reste</Trans>)} value={currencyFormat(item.reste / 100, item.devise)} color={item.reste?MOBCOLORS.orange.color:MOBCOLORS.green.color}/>
                                <Item name={(<Trans>Réglé</Trans>)} value={currencyFormat(item.payed / 100, item.devise)} color={item.payed?MOBCOLORS.green.color:MOBCOLORS.orange.color}/>
                            </>
                        )}

                    </MobCard>


                    <MobCard>
                        <div style={{display:"flex",flexDirection:"row",textAlign:"center",justifyContent:"center",alignItems:"center"}}>
                            <span style={{color:"#333",fontSize:18,fontWeight:"300"}}><Trans>Detail</Trans></span>
                        </div>

                        <FicheSubmit id={item.id} mobile sheetContext={this.props.sheetContext} />
                    </MobCard>
                </div>


                <ModalLink getRef={(ref) => {
                    this.modalLink = ref
                    this.forceUpdate()
                }} onFinish={() => {}}/>
                <ModalUser getRef={(ref) => this.modalUser = ref} onFinish={() => {
                }}/>
                <ModalContact getRef={(ref) => this.modalContact = ref} onFinish={() => {
                }}/>
                <ModalCerfa getRef={(ref) => this.modalCerfa = ref} onFinish={() => this.getData(true)}/>
                <ModalEditCerfa getRef={(ref) => this.modalEditCerfa = ref} onFinish={() => this.getData(true)}/>
                <ModalCerfaGroupe getRef={(ref) => this.modalCerfaGroupe = ref} onFinish={() => this.getData(true)}/>
                <ModalChangeContact getRef={(ref) => this.modalChangeContact = ref} onFinish={() => this.getData()}/>
                <ModalChangeOrigin getRef={(ref) => this.modalChangeOrigin = ref} onFinish={() => this.getData()}/>
                <ModalDeletePaiement getRef={(ref) => this.modalDeletePaiement = ref} onFinish={() => this.getData()}/>
                <ModalMessages getRef={(ref) => this.modalMessages = ref} onFinish={() => {
                }}/>
            </div>
        )
    }
}

function withNavigate(Component) {
    return function WrappedComponent(props) {
        const navigate = useNavigate();
        return <Component {...props} navigate={navigate} />;
    }
}

export default withNavigate(withActionSheet(SheetSubmitDetail))

function Divider(){
    return(
        <div style={{width:"100%",paddingLeft:"5%",opacity:0.05}}>
            <div style={{width:"100%",borderTop:"1px solid #4A5568"}}/>
        </div>
    )
}

function DividerVertical(){
    return(
        <div style={{height:20,opacity:0.05}}>
            <div style={{height:"100%",borderLeft:"1px solid #4A5568"}}/>
        </div>
    )
}

function Section({title,children})
{
    return(
        <div style={{display:"flex",flexDirection:"column",gap:10}}>

            <div style={{display:"flex",flexDirection:"row",textAlign:"center",justifyContent:"center",alignItems:"center"}}>
                <span style={{color:"#333",fontSize:18,fontWeight:"300"}}>{title}</span>
            </div>

            <div style={{display:"flex",flexDirection:"column",gap:5,marginTop:10}}>
                {children}
            </div>
        </div>
    )
}

function Item({name,value,color,children,bold})
{
    return(
        <div style={{display:"flex",flexDirection:"column",gap:10,padding:"0 2.5%"}}>
            <div style={{display:"flex",flexDirection:"row",justifyContent:"space-between",alignItems:"flex-start",fontSize:15}}>

                <span style={{width:"40%",fontStyle:"italic",fontWeight:"300",color:"#333",fontSize:13}}>{name}</span>

                <div style={{display:"flex",textAlign:"right",alignItems:"flex-end",maxWidth:"60vw",overflow:"hidden",textOverflow:'ellipsis',color:color || MOBCOLORS.blue.color}}>
                    {value ?(
                        <span>{value.replaceAll("undefined","").trim() || t`[Inconnu]`}</span>
                    ):(
                        <div>{children}</div>
                    )}
                </div>
            </div>

            <Divider/>
        </div>
    )
}
